"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EmailSeparator = _interopRequireDefault(require("./EmailSeparator"));
var _analytics = _interopRequireDefault(require("./helpers/analytics"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var InviteEmail = /*#__PURE__*/function (_Component) {
  function InviteEmail(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, InviteEmail);
    _this = _callSuper(this, InviteEmail, [props]);
    (0, _defineProperty2["default"])(_this, "state", {
      loading: false,
      emails: []
    });
    (0, _defineProperty2["default"])(_this, "handleSubmit", function (e) {
      _this.setState({
        loading: true
      });
      var booking = _this.props.booking;
      var emails = _this.state.emails;
      var sendCrewInvitation = _this.props.sendCrewInvitation;
      e.preventDefault();
      sendCrewInvitation(booking, emails).then(function (response) {
        _this.setState({
          loading: false
        });
        if (response.status === 'success') {
          _analytics["default"].sharedPlan({
            booking_id: booking.id
          });
          _this.setState({
            emails: []
          });
        }
        _this.tokenBox.clearTokens();
      });
    });
    (0, _defineProperty2["default"])(_this, "handleChange", function (e) {
      _this.setState({
        emails: e.target.value.split(',')
      });
    });
    _this.setEmails = _this.setEmails.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(InviteEmail, _Component);
  return (0, _createClass2["default"])(InviteEmail, [{
    key: "setEmails",
    value: function setEmails(emails) {
      var emailStrings = emails.map(function (email) {
        return email.text;
      });
      this.setState({
        emails: emailStrings
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        loading = _this$state.loading,
        emails = _this$state.emails;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "invite-emails margin-bottom-md"
      }, /*#__PURE__*/_react["default"].createElement(_EmailSeparator["default"], {
        setEmails: this.setEmails,
        ref: function ref(instance) {
          _this2.tokenBox = instance;
        },
        placeholder: "username@email.com, seperate emails with comma"
      }), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn--primary margin-left-md",
        onClick: this.handleSubmit,
        disabled: loading || !emails.length
      }, loading ? 'Sending...' : 'Send'));
    }
  }]);
}(_react.Component);
InviteEmail.propTypes = {
  sendCrewInvitation: _propTypes["default"].func.isRequired,
  booking: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = InviteEmail;